import { FormattedMessage } from 'react-intl';

export const userAvatarMessages = {
  'userAvatar.menu.account.label': (
    <FormattedMessage
      id="userAvatar.menu.account.label"
      defaultMessage="Account"
    />
  ),
  'userAvatar.menu.registry.label': (
    <FormattedMessage
      id="userAvatar.menu.registry.label"
      defaultMessage="Registry"
    />
  ),
  'userAvatar.menu.manageUsers.label': (
    <FormattedMessage
      id="userAvatar.menu.manageUsers.label"
      defaultMessage="Manage users"
    />
  ),
  'userAvatar.menu.logout.label': (
    <FormattedMessage
      id="userAvatar.menu.logout.label"
      defaultMessage="Log out"
    />
  ),
};
